<pcg-resizable-widget>
    <span widget-title>Issuance Quick Scan</span>
    <div widget-meta>
        @if (canAccess()) {
            <p-toggleswitch
                [ngModel]="sysInvQuickNavService.openInNewTab()"
                (ngModelChange)="sysInvQuickNavService.openInNewTab.set($event)"
                ariaLabel="Open in new tab"
                pTooltip="Open in new tab"
                tooltipPosition="left"
            >
                <ng-template #handle>
                    <i class="pi pi-plus-circle"></i>
                </ng-template>
            </p-toggleswitch>
        }
    </div>
    <div
        class="px-4 pt-2 pb-2"
        role="search"
        aria-label="Issuance Quick Scan"
        widget-body
    >
        @if (canAccess()) { <pcg-sysinv-quick-nav [embedded]="true" /> } 
        @else { <p class="text-muted small mb-0">Issuance Quick Scan requires Issuance access.</p> }
    </div>
</pcg-resizable-widget>
